/** Full display name for API customer objects (supports legacy `name` and first/last). */
export function formatCustomerDisplayName(c) {
  if (!c) return '';
  if (typeof c.name === 'string' && c.name.trim()) return c.name.trim();
  const first = (c.firstName || '').trim();
  const last = (c.lastName || '').trim();
  return [first, last].filter(Boolean).join(' ') || '';
}
